import { render, staticRenderFns } from "./cpview.vue?vue&type=template&id=7885c3b7&scoped=true"
import script from "./cpview.vue?vue&type=script&lang=js"
export * from "./cpview.vue?vue&type=script&lang=js"
import style0 from "./cpview.vue?vue&type=style&index=0&id=7885c3b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7885c3b7",
  null
  
)

export default component.exports